
import { ThreeView } from '../../../view3d/webcad/View3dWebCad';
import * as THREE from 'three';
import { Voronoi, BoundingBox, Site, Diagram, Edge, Cell, Halfedge } from '../../Voronoi/index';
import { PointInfo } from '../../WalltoFittingInfo';
import { Line2, Point, Picker } from '../../graphicLibs/index';
import { CreateObject } from '../../CreateObject';
import { CreatePointData } from '../CreatePointData';

type statusEdge = {
    index: number, 
    edge: Edge, 
    start_flag: number // start_flag : 0 -> edge.va, 1 -> edge.vb
};

/**
 * 外周補完
 * */
export class SearchOuterWall {

    public copyPointList: PointInfo[];

    constructor(public pointList: PointInfo[]) {
        this.copyPointList = pointList.map((info: PointInfo) => {
            return {
                point: info.point.clone(),
                isDelete: info.isDelete,
                isExist: info.isExist
            }
        });
        const createPointData = new CreatePointData(this.copyPointList);
        createPointData.execute();
        const roomList = createPointData.roomList;
        const branchList = createPointData.branchList;
        // 枝壁と部屋の内外判定を行い、内側にあったら判定に含めない
        roomList.map((rooms: number[]) => {
            const points = rooms.map((index: number) => new THREE.Vector2(this.copyPointList[index].point.x, this.copyPointList[index].point.z));
            branchList.forEach((index: number) => {
                // 内外判定
                const isCheck = new Picker()._Check(points, new THREE.Vector2(this.copyPointList[index].point.x, this.copyPointList[index].point.z));
                // 直線上の点
                const isCheckOnLine = this.isOnLine(points, new THREE.Vector2(this.copyPointList[index].point.x, this.copyPointList[index].point.z));
                const isCheckOnLine_ = this.isOnLine(points, new THREE.Vector2(this.copyPointList[Point.nextPoint(index)].point.x, this.copyPointList[Point.nextPoint(index)].point.z));
                if ((isCheckOnLine && !isCheck || isCheckOnLine_ && !isCheck) && (isCheckOnLine && isCheckOnLine_) == false) return;
                // 壁のもう一方の頂点が直線であれば、削除する
                if (isCheck || (isCheckOnLine && isCheckOnLine_)) {
                    this.copyPointList[index].isDelete = true;
                    this.copyPointList[Point.nextPoint(index)].isDelete = true;
                }
            });
        });
    }

    public execute(): PointInfo[] {

        // const view = (index: number) => {
        //     const mesh = new THREE.Mesh(new THREE.SphereGeometry(0.1), new THREE.MeshBasicMaterial({color: 0xFF0000}));
        //     mesh.position.set(this.copyPointList[index].point.x, 0.15, this.copyPointList[index].point.z);
        //     ThreeView.get().wcItemmgr.addLiDARShapes(mesh);
        // }
        
        const voronoi = new Voronoi();
        const bbox: BoundingBox = this.bounsRect();
        const sites: Site[] = this.createSiteList();
        
        const diagram: Diagram = voronoi.compute(sites, bbox);
        // const edges = diagram.edges;
        // this.draw(sites, edges);
        
        // Edgeから外枠を削除
        const innerEdges = diagram.edges.filter((edge: Edge) => {
            const outerX = () => ((edge.va.x == bbox.xl && edge.vb.x == bbox.xl) || (edge.va.x == bbox.xr && edge.vb.x == bbox.xr));
            const outerY = () => ((edge.va.y == bbox.yb && edge.vb.y == bbox.yb) || (edge.va.y == bbox.yt && edge.vb.y == bbox.yt));
            if (outerX() || outerY()) return false;
            else return true;
        });

        // this.draw(sites, innerEdges);

        // ボロノイ辺の末端を探す
        const branchEdge = this.getBranchEdge(innerEdges); // getBranchEdgeの引数とnextSearchEdgeの引数は同じでないといけない
        
        // 近傍点がない頂点のインデックスを取得
        const notNearPoint: number[] = this.notNearIndexes();
        if(notNearPoint.length == 0) return this.pointList;

        // notNearPoint.forEach((index: number) => view(index));

        // edgeと壁の当たり判定
        // const intersect = (edge: Edge, index: number): boolean => {
        //     const next = Point.nextPoint(index);
        //     return this.intersectVoronoiAndWall(edge, this.pointList[index].point, this.pointList[next].point);
        // }

        // 次のボロノイ辺を探す
        const createWallIndexes: number[] = [];
        const search = (edges: statusEdge[]) => {
            if (edges.length == 0) return;

            for (let i = 0; i < edges.length; i++) {
                const pointIndex = (x: number, y: number): number => sites.findIndex((site: Site) => site.x == x && site.y == y);
    
                const edge = edges[i].edge;
                if (edge.rSite == null || edge.lSite == null) continue;
                const i1 = pointIndex(edge.rSite.x, edge.rSite.y);
                const i2 = pointIndex(edge.lSite.x, edge.lSite.y);
                const index = i1 % 2 == 0 ? i1 : i2;
                const next = i1 % 2 == 0 ? i2 : i1;
    
                // ボロノイ辺の隣Site同士の頂点が壁であったら
                if (this.exsistWall(sites, edge.rSite.x, edge.rSite.y, edge.lSite.x, edge.lSite.y)) continue;

                if (this.copyPointList[index].isDelete || this.copyPointList[next].isDelete) continue;
    
                // 片方が近傍点がない点 && 壁でなかったら候補とする
                if (notNearPoint.includes(index) || notNearPoint.includes(next)) {
                    createWallIndexes.push(...[index, next]);
                    continue;
                }

                const status_edge = this.nextSearchEdge(edges[i], diagram.edges);
                search(status_edge);
            }
        }
        
        search(branchEdge);

        const addPoints: {index: number, pointInfo: PointInfo}[] = [];
        for (let i = 0; i < createWallIndexes.length; i+=2) {
            const index = createWallIndexes[i];
            const next = createWallIndexes[i+1];
            const info: PointInfo = {
                point: this.pointList[index].point.clone(),
                isExist: false,
                isDelete: false
            };
            const info_: PointInfo = {
                point: this.pointList[next].point.clone(),
                isExist: false,
                isDelete: false
            };
            addPoints.push({index: index, pointInfo: info});
            addPoints.push({index: next, pointInfo: info_});
        }

        // // 軸平行でない壁の場合は、軸平行の壁を２枚追加する
        this.addPointInfos(addPoints);

        // 壁が重なってできた場合は、削除する
        // const overlapWall = new OverlapWall(this.pointList);
        // overlapWall.length(5);
        // overlapWall.execute();

        // createWallIndexes.forEach((index: number) => view(index));

        return this.pointList;

    }

    // 軸平行でない壁の場合は、軸平行の壁を２枚追加する
    private addPointInfos(addPoints: {index: number, pointInfo: PointInfo}[]) {
        for (let i = 0; i < addPoints.length; i+=2) {
            const point = addPoints[i].pointInfo.point.clone();
            const next = addPoints[i + 1].pointInfo.point.clone();
            const dir = next.clone().sub(point);
            const rad = new THREE.Vector2(dir.x, dir.z).angle();
            if (rad == 0 || rad == Math.PI / 2 || rad == Math.PI || rad == 3 * Math.PI / 2 || rad == Math.PI) {
                this.pointList.push(addPoints[i].pointInfo);
                this.pointList.push(addPoints[i + 1].pointInfo);
                continue;
            }
            const t1 = Point.nextPoint(addPoints[i].index);
            const t2 = Point.nextPoint(addPoints[i+1].index);
            const p1 = new THREE.Vector3(point.x, point.y, next.z);
            const p2 = new THREE.Vector3(point.x, point.y, next.z);
            this.createLine(point,p1);
            this.createLine(p2,next);
        }
    }

    // 線分(p1-p2)上に壁が存在している場合は、カットして作成する
    private createLine(p1: THREE.Vector3, p2: THREE.Vector3) {
        const e = 0.01;
        if (p2.clone().sub(p1).clone().length() < e) return;    // p1-p2間の距離がeより短ければ処理しない

        const isExist = (lines_: THREE.Vector3[], pos1: THREE.Vector3, pos2: THREE.Vector3): boolean => {
            if (pos2.clone().sub(pos1).clone().length() < e) return true;
            const index = lines_.findIndex((val) => val.clone().equals(pos1));
            if (index != -1 && lines_.length > index + 1) return lines_[index + 1].clone().equals(pos2);
            return false;
        }

        // カット
        const cut = (pos: THREE.Vector3[], index: number) => {
            pos = pos.map((p: THREE.Vector3) => p.clone());
            console.log(index);
            
            for (let j = 0; j < pos.length; j+=2) {
                for (let i = index; i < this.pointList.length; i++) {
                    const point = this.pointList[i].point;
                    const dir1 = point.clone().sub(pos[j]);
                    if (dir1.clone().length() < e && point.clone().sub(pos[j+1]).clone().length() < e) continue;    //3点の距離が短ければ
                    const dir2 = pos[j+1].clone().sub(pos[j]);
                    if (- e < (dir1.clone().dot(dir2) / dir2.length()) && (dir1.clone().dot(dir2) / dir2.length()) < dir2.length() + e) {
                        // y方向の高さがe以内なら
                        const height = dir1.clone().cross(dir2).clone().divideScalar(dir2.length());
                        if (-e < height.length() && height.length() < e) {
                            if (!isExist(lines, pos[j], point) && !isExist(lines, point, pos[j+1])) {
                                lines.splice(j, 2);
                                lines.push(...[pos[j], point]);
                                lines.push(...[point, pos[j+1]]);
                            }
                            cut(lines, i+1);
                            return;
                        }
                    }
                }
            }
            return;
        }

        let lines: THREE.Vector3[] = [p1, p2];
        cut(lines, 0);        

        if (lines.length == 0) return;
        console.log(lines);
        

        // 壁と重なっている部分は削除
        const deleteIndex = [];
        for (let i = 0; i < lines.length; i+=2) {
            const start = lines[i];
            const end = lines[i+1];
            for (let j = 0; j < this.pointList.length; j+=2) {
                const point = this.pointList[j].point;
                const next = this.pointList[j+1].point;

                if ((start.clone().equals(point) && end.clone().equals(next)) || (start.clone().equals(next) && end.clone().equals(point))) {
                    deleteIndex.push(i);
                    deleteIndex.push(i+1);
                    continue;
                }

                // 頂点が壁上に存在しているたら削除
                const execute = (p: THREE.Vector3) => {
                    const dir1 = p.clone().sub(point);
                    const dir2 = next.clone().sub(point);
                    // 線分上にある
                    if (0 < (dir1.clone().dot(dir2) / dir2.length()) && (dir1.clone().dot(dir2) / dir2.length()) < dir2.length()) {                   
                        // e以内 高さ方向
                        const height = dir1.clone().cross(dir2).clone().divideScalar(dir2.length());
                        if (height.length() < e) {
                            deleteIndex.push(i);
                            deleteIndex.push(i+1);
                        }
                    }
                }

                if (start.clone().equals(point) || start.clone().equals(next)) {
                    execute(end);
                }

                if (end.clone().equals(point) || end.clone().equals(next)) {
                    execute(start);
                }

            }
        }

        lines = lines.filter((pos: THREE.Vector3, index: number) => !deleteIndex.includes(index));
        
        if (lines.length == 0) return;
        console.log(lines);
                
        // pointListにセットする
        const set = (point: THREE.Vector3) => {
            const info: PointInfo = {
                point: point.clone(),
                isExist: false,
                isDelete: false
            };
            this.pointList.push(info);
        }

        lines.forEach((pos: THREE.Vector3) => {
            set(pos);
        });

    }

    // 壁が存在しているか
    private exsistWall(sites: Site[], x1: number, y1: number, x2: number, y2: number): boolean {
        for (let i = 0; i < sites.length; i+=2) {
            if ((sites[i].x == x1 && sites[i].y == y1 && sites[i+1].x == x2 && sites[i+1].y == y2)
                || (sites[i].x == x2 && sites[i].y == y2 && sites[i+1].x == x1 && sites[i+1].y == y1)) return true;       
        }
        return false;
    }

    // 近傍点がない点を取得
    private notNearIndexes(): number[] {
        // vec3のリストに変換
        const infos = this.copyPointList.filter((info: PointInfo) => info.isDelete == false);
        const pointList_ = infos.map((info: PointInfo) => info.point.clone());
        // 近傍点がない点を取得
        const notNearPoint: number[] = [];
        for (let i = 0; i < this.copyPointList.length; i++) {
            if (this.copyPointList[i].isDelete == true) continue;
            const point = this.copyPointList[i].point.clone();
            const num = Point.numNearPoints(point, pointList_);
            if (num == 1) notNearPoint.push(i);
        }

        return notNearPoint;
    }


    // ボロノイ辺から次のボロノイ辺を探す
    private nextSearchEdge(edge_status: statusEdge, edges: Edge[]): statusEdge[] {
        const e = 0.01;
        const result: statusEdge[] = [];
        for (let i = 0; i < edges.length; i++) {
            if (edge_status.index == i) continue;
            const point = edge_status.start_flag == 0 ? new THREE.Vector3(edge_status.edge.vb.x, edge_status.edge.vb.y, 0) : new THREE.Vector3(edge_status.edge.va.x, edge_status.edge.va.y, 0);
            const next1 = new THREE.Vector3(edges[i].va.x, edges[i].va.y, 0);
            const next2 = new THREE.Vector3(edges[i].vb.x, edges[i].vb.y, 0);
            if (point.distanceTo(next1) < e) result.push({index: i, edge: edges[i], start_flag: 0});
            if (point.distanceTo(next2) < e) result.push({index: i, edge: edges[i], start_flag: 1});
        }

        return result;
    }

    // EdgeからVector3のリストを作成する
    private edgePointList = (edges: Edge[]): THREE.Vector3[] => {
        return edges.map((edge: Edge) => [new THREE.Vector3(edge.va.x, edge.va.y, 0), new THREE.Vector3(edge.vb.x, edge.vb.y, 0)])
                                    .flat();
    }

    // 末端のEdgeを取得
    private getBranchEdge(edges: Edge[]): statusEdge[] {
        // edgeの始点終点リスト作成
        const edgesPointList: THREE.Vector3[] = this.edgePointList(edges);
        const res: statusEdge[] = []; 
        for (let i = 0; i < edges.length; i++) {
            const p1 = new THREE.Vector3(edges[i].va.x, edges[i].va.y, 0);
            const p2 = new THREE.Vector3(edges[i].vb.x, edges[i].vb.y, 0);
            if (Point.numNearPoints(p1, edgesPointList) == 1) res.push({index: i, edge: edges[i], start_flag: 0});
            if (Point.numNearPoints(p2, edgesPointList) == 1) res.push({index: i, edge: edges[i], start_flag: 1});
        }
        return res;
    }
    
    // ボロノイ辺と壁の交差
    private intersectVoronoiAndWall(edge: Edge, point1: THREE.Vector3, point2: THREE.Vector3): boolean {
        const intersect = Line2.judgeIentersected(edge.va.x, edge.va.y, edge.vb.x, edge.vb.y, point1.x, point1.z, point2.x, point2.z);
        
        return intersect;
    }

    // 敷地の最大最小のBoundingBoxを取得
    private bounsRect(): BoundingBox {
        const min_x = -30;
        const min_y = -30;
        const max_x = 30;
        const max_y = 30;
      
        return {xl: min_x, xr: max_x, yt: min_y, yb: max_y};
    }

    // SiteListの作成する
    private createSiteList(): Site[] {
        return this.copyPointList.map((info: PointInfo, index: number): Site => {
            // 頂点座標を小数第一位までとする（小数第二位で四捨五入）
            return {id: index, x: Math.round(info.point.x * 10) / 10, y: Math.round(info.point.z * 10) / 10};
        });
    }

    public draw(sites: Site[], edges: Edge[]) {
        // sites.forEach((point: Site) => {
        //     const mesh = new THREE.Mesh(new THREE.SphereGeometry(0.1), new THREE.MeshBasicMaterial({color: 0x6699FF}));
        //     mesh.position.set(point.x, 0.15, point.y);
        //     ThreeView.get().wcItemmgr.addLiDARShapes(mesh);
        // });
        for (let i = 0; i< sites.length; i+=2) {
            const vec3_1 = new THREE.Vector3(sites[i].x, 0.1, sites[i].y);
            const vec3_2 = new THREE.Vector3(sites[i+1].x, 0.1, sites[i+1].y);
            const object = CreateObject.createLine([vec3_1.clone(), vec3_2.clone()], new THREE.Color('#808080'));
            ThreeView.get().wcItemmgr.addLiDARShapes(object);
        }
        
        // edges.forEach((edge: Edge) => {
        //     if (edge.lSite != null) {
        //         const mesh = new THREE.Mesh(new THREE.SphereGeometry(0.1), new THREE.MeshBasicMaterial());
        //         mesh.position.set(edge.lSite.x, 0.1, edge.lSite.y);
        //         ThreeView.get().wcItemmgr.addLiDARShapes(mesh);
        //     }
        //     if (edge.rSite != null) {
        //         const mesh_ = new THREE.Mesh(new THREE.SphereGeometry(0.1), new THREE.MeshBasicMaterial());
        //         mesh_.position.set(edge.rSite.x, 0.1, edge.rSite.y);
        //         ThreeView.get().wcItemmgr.addLiDARShapes(mesh_);
        //     }
        // });
        
        const points_ = edges.map((edge: Edge) => {
            const p1 = edge.va;
            const p2 = edge.vb;
            const origin = new THREE.Vector3(p1.x, 0.1, p1.y);
            const next = new THREE.Vector3(p2.x, 0.1, p2.y);
            return [origin, next];
        }).flat();
        for (let i = 0; i< points_.length; i+=2) {
            const object = CreateObject.createLine([points_[i].clone(), points_[i+1].clone()], new THREE.Color('#00ff00'));
            ThreeView.get().wcItemmgr.addLiDARShapes(object);
        }
    }

    // voronoi test
    public test() {
        const voronoi = new Voronoi();
        const bbox: BoundingBox = {xl: -30, xr: 30, yt: -30, yb: 30}; // xl is x-left, xr is x-right, yt is y-top, and yb is y-bottom
        const sites: Site[] = [ {id: 0, x: 2, y: 2}, {id: 1, x: 0.5, y: 2.5}, {id: 2, x: 4, y: 1}, {id: 3, x: 0, y: 0}, {id: 4, x: 8, y: 6}, {id: 5, x: 10, y: 3}, {id: 6, x: 40, y: 5} /* , ... */ ];
        
        const diagram: Diagram = voronoi.compute(sites, bbox);
        const edges = diagram.edges;

        this.draw(sites, edges);
    }

    // 直線上の頂点はtrue
    private isOnLine(points: THREE.Vector2[], target: THREE.Vector2): boolean {
        for (let i = 0; i < points.length; i++) {
            const p1 = points[i];
            const p2 = points[(i + 1) % points.length];
            
            const dir = target.clone().sub(p1);
            const next = p2.clone().sub(p1);
            const length = dir.clone().dot(next) / (next.length());
            /** 垂直に下したときの線が線分上になかったら除外 */
            if (next.length() < length || length < 0) continue;

            const line = dir.clone().cross(next) / next.length();
            /** 直線上 */
            if (Math.abs(line) < 0.05) return true;
        }

        return false;
    }

}